import { forwardRef, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input, type InputProps } from './Input';

/**
 * `Input` de contraseña con botón para mostrarla u ocultarla.
 *
 * No cambia el estilo del campo: sigue siendo el `Input` del sistema (mismo foco, mismo
 * estado de error) y solo añade el botón del slot derecho. Se usa dentro de un `Field`,
 * que es quien aporta la etiqueta y el mensaje de error.
 */

export type PasswordInputProps = Omit<InputProps, 'type' | 'rightSlot'>;

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  function PasswordInput({ leftIcon, className, ...props }, ref) {
    const [visible, setVisible] = useState(false);

    return (
      <Input
        ref={ref}
        type={visible ? 'text' : 'password'}
        leftIcon={leftIcon}
        className={className}
        rightSlot={
          <button
            type="button"
            onClick={() => setVisible((value) => !value)}
            aria-label={visible ? 'Ocultar la contraseña' : 'Mostrar la contraseña'}
            aria-pressed={visible}
            title={visible ? 'Ocultar la contraseña' : 'Mostrar la contraseña'}
            className="flex size-8 items-center justify-center rounded-control text-ink-faint transition-colors hover:bg-surface-muted hover:text-ink-soft"
          >
            {visible ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        }
        {...props}
      />
    );
  },
);
